<script>
  import { onMount } from "svelte";
  import { getProperty } from "../../Common/tools";
  import {getLists, getSegments, SMS, VOICE} from "./static";
  import {External, M} from "../../external";
  import WhatsAppEditor from "../../CRM/Popups/messages/WhatsAppEditor.svelte";
  import {WHATSAPP} from "../static";
  import SMSEditor from "../../CRM/Popups/messages/SMSEditor.svelte";
  import VoiceEditor from "../../CRM/Popups/messages/VoiceEditor.svelte";

  export let campaign,
    changeTab,
    cache,
    next,
    save;

  let selectedListsText = "",
    selectedSegmentsText = "",
    message = campaign.content;

  let setListNames = () => {
    let selected = [];
    campaign.data.lists.forEach(function (list) {
      let prop = getProperty(cache.lists, "id", list.id);
      if (prop != null) {
        selected.push(prop.name);
      }
    });

    selectedListsText = M.LIST + ": " + selected.join(", ");
  };

  let setSegmentNames = () => {
    let selected = [];
    campaign.data.segments.forEach(function (segment) {
      let prop = getProperty(cache.segments, "id", segment.id);
      if (prop != null) {
        selected.push(prop.name);
      }
    });

    selectedSegmentsText = M.SEGMENT + ": " + selected.join(", ");
  };

  let onSend = () => {
    save(false, function () {
    });
  };

  let enableSalesUtm = () => {
    campaign.data.salesUtm = campaign.data.salesUtm ? null : {};
  }

  onMount(function () {
    if (campaign.data.lists && campaign.data.lists.length) {
      if (!cache.lists) {
        getLists(function (lists) {
          cache.lists = lists;
          setListNames();
        });
      } else {
        setListNames();
      }
    }

    if (campaign.data.segments && campaign.data.segments.length) {
      if (!cache.segments) {
        getSegments(function (segments) {
          cache.segments = segments;
          setSegmentNames();
        });
      } else {
        setSegmentNames();
      }
    }
  });

  function onChange(msg) {
    campaign.content = msg;
  }

</script>

<style>
    .contact-message-dialog-footer {
        padding: 30px 0px 15px 0px;
    }
</style>

<div class="flex-1 overflow account-settings store-products">
  <div class="col20 f-left">
    <div class="top-background-wrapper wide-top-background">
      <div class="top-background" style="max-width: 850px;">
        <div class="text-wrapper">
          <div class="flex-centered f-left booking-buttons-wrapper none">
            <div>
              <h1 class="members-title f-left mb-0">{M.SYSTEM_EMAILS}</h1>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content-wrapper horizontal-flex-table" style="max-width: 850px; margin-top: 100px;" data-role="table-content">
      <div class="sections-wrapper members-wrapper horizontal-flex-table">
        <div class="section-bg members-wrapper products-wrapper crm-table-outer" style="box-shadow: none; padding: 0;">
          <div class="system-emails-wrapper">
            <div class="col20 f-left t-center mb-15">
              <span class="material-icons-outlined fingerprint-icon" style="font-size: 26px;"> settings </span>
            </div>
            <h2 class="col20 f-left t-center" style="font-size: 26px;">{M.CAMPAIGN_SETTINGS}</h2>
            <div class="col20 f-left email-section-description t-center mt-10 mb-25 none" />
            <div class="col20 f-left mt-15">
              <div class="email-inputs-wrapper">

                <h5>{M.TYPE}</h5>
                <div class="recipients-summary f-left col20 mt-10 gray-section">
                  <span class="col20 f-left recipients-total f-16" style="">{External.CRM_MESSAGE_CHANNEL.getChannelName(campaign.content.channel)}</span>
                </div>

                {#if campaign.type !== VOICE}
                  <div class="popup-input-wrapper mb-0 mt-35">
                    <div class="checkbox-wrapper">
                      <input id="trackSalesCheck" class="css-checkbox select-cbx" checked={campaign.data.salesUtm}
                             type="checkbox" name="trackSalesCheck" on:change={enableSalesUtm}/>
                      <label for="trackSalesCheck" class="css-label">{M.TRACK_CAMPAIGN_SALES}</label>
                    </div>
                    {#if campaign.data.salesUtm}
                      <div class="recipients-summary f-left col20 mt-5 mb-5 gray-section">
                        <div class="info">
                          <span class="light-gray-text">{M.SALES_TRACKING_UTM_DESC}</span>
                        </div>
                        <div class="popup-input-wrapper mt-15">
                          <span class="recipients-total f-16 f-left mr-5" style="display: inline">{M.SOURCE}</span>
                          <span class="light-gray-text" style="line-height: 1.4">{M.FB_GOOGLE_NEWSLETTER}</span>
                          <input type="text" placeholder={M.SOURCE} bind:value={campaign.data.salesUtm.source} class="col20 f-left clear-left" style="margin-top: 5px" />
                        </div>
                        <div class="popup-input-wrapper">
                          <span class="recipients-total f-16 f-left mr-5" style="display: inline">{M.CAMPAIGN}</span>
                          <span class="light-gray-text" style="line-height: 1.4">{M.DEAL_PROMOTION}</span>
                          <input type="text" placeholder={M.CAMPAIGN} bind:value={campaign.data.salesUtm.campaign} class="col20 f-left clear-left" style="margin-top: 5px"/>
                        </div>
                        <div class="popup-input-wrapper">
                          <span class="recipients-total f-16 f-left mr-5" style="display: inline">{M.UTM_MEDIUM}</span>
                          <span class="light-gray-text" style="line-height: 1.4">{M.SOCIAL_PPC_EMAIL}</span>
                          <input type="text" placeholder={M.UTM_MEDIUM} bind:value={campaign.data.salesUtm.medium} class="col20 f-left clear-left" style="margin-top: 5px"/>
                        </div>
                      </div>
                    {/if}
                  </div>
                {/if}

                <h5 class="col20 f-left mt-35 f-18">{M.RECIPIENTS}</h5>
                <div class="recipients-summary f-left col20 mt-10 gray-section">
                  <span class="col20 f-left recipients-total f-16">{M.TOTAL} {campaign.data.audience || 0}</span>
                  {#if selectedListsText}
                    <span class="col20 f-left recipients-listed mt-5">{selectedListsText}</span>
                  {/if}
                  {#if selectedSegmentsText}
                    <span class="col20 f-left recipients-listed mt-5">{selectedSegmentsText}</span>
                  {/if}
                </div>

                <h5 class="col20 f-left mt-35 f-18">{M.MESSAGE}</h5>
                <div class="f-left col20 mt-10 gray-section align-center" style="position:relative">
                  {#if campaign.type === SMS}
                    <SMSEditor {message} {onChange} utm={campaign.data.salesUtm}/>
                  {:else if campaign.type === WHATSAPP}
                    <WhatsAppEditor {message} {onChange} utm={campaign.data.salesUtm}>
                      <svelte:fragment slot="footerButtons" let:isSendAllowed let:isNewTemplate let:submitTemplate>
                        <div class='f-left contact-message-dialog-footer t-left flex-none'>
                          {#if isNewTemplate}
                            <a on:click={submitTemplate} class='middle-button f-none inline-block rounded-effect blue'>
                              {M.SUBMIT_MESSAGE_FOR_APPROVAL}
                            </a>
                          {/if}
                        </div>
                      </svelte:fragment>
                    </WhatsAppEditor>
                  {:else if campaign.type === VOICE}
                    <VoiceEditor {message} {onChange} />
                  {/if}
                </div>
                <div class="col20 f-left flex justify-center mt-35 mb-35">
                  <a data-action="nextPage" on:click={next} class="big-button blue circle-effect transition-bg f-left" style="margin-left:5px;">{M.NEXT} →</a>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
